/* eslint-disable import/no-duplicates */
/* eslint-disable object-shorthand */
// 保留字：default、do、in，避免报错都加下划线前缀_ ，短横杠-用下划线_代替
// -.svg、default.svg、others.svg、undefined.svg 图片是相同的
// import _undefined from '@/pages/home/assets/img/flag/undefined.svg';
import _undefined from '@/pages/home/assets/img/flag/defcountry.svg';
import _us from '@/pages/home/assets/img/flag/us.svg';
import _uy from '@/pages/home/assets/img/flag/uy.svg';
import _uz from '@/pages/home/assets/img/flag/uz.svg';
import _va from '@/pages/home/assets/img/flag/va.svg';
import _vc from '@/pages/home/assets/img/flag/vc.svg';
import _ve from '@/pages/home/assets/img/flag/ve.svg';
import _vg from '@/pages/home/assets/img/flag/vg.svg';
import _vi from '@/pages/home/assets/img/flag/vi.svg';
import _vn from '@/pages/home/assets/img/flag/vn.svg';
import _vu from '@/pages/home/assets/img/flag/vu.svg';
import _wf from '@/pages/home/assets/img/flag/wf.svg';
import _ws from '@/pages/home/assets/img/flag/ws.svg';
import _xk from '@/pages/home/assets/img/flag/xk.svg';
import _ye from '@/pages/home/assets/img/flag/ye.svg';
import _yt from '@/pages/home/assets/img/flag/yt.svg';
import _za from '@/pages/home/assets/img/flag/za.svg';
import _zm from '@/pages/home/assets/img/flag/zm.svg';
import _zw from '@/pages/home/assets/img/flag/zw.svg';
// import _ from '@/pages/home/assets/img/flag/-.svg';
import _ from '@/pages/home/assets/img/flag/defcountry.svg';
import _ad from '@/pages/home/assets/img/flag/ad.svg';
import _ae from '@/pages/home/assets/img/flag/ae.svg';
import _af from '@/pages/home/assets/img/flag/af.svg';
import _ag from '@/pages/home/assets/img/flag/ag.svg';
import _ai from '@/pages/home/assets/img/flag/ai.svg';
import _al from '@/pages/home/assets/img/flag/al.svg';
import _am from '@/pages/home/assets/img/flag/am.svg';
import _ao from '@/pages/home/assets/img/flag/ao.svg';
import _aq from '@/pages/home/assets/img/flag/aq.svg';
import _ar from '@/pages/home/assets/img/flag/ar.svg';
import _as from '@/pages/home/assets/img/flag/as.svg';
import _at from '@/pages/home/assets/img/flag/at.svg';
import _au from '@/pages/home/assets/img/flag/au.svg';
import _aw from '@/pages/home/assets/img/flag/aw.svg';
import _ax from '@/pages/home/assets/img/flag/ax.svg';
import _az from '@/pages/home/assets/img/flag/az.svg';
import _ba from '@/pages/home/assets/img/flag/ba.svg';
import _bb from '@/pages/home/assets/img/flag/bb.svg';
import _bd from '@/pages/home/assets/img/flag/bd.svg';
import _be from '@/pages/home/assets/img/flag/be.svg';
import _bf from '@/pages/home/assets/img/flag/bf.svg';
import _bg from '@/pages/home/assets/img/flag/bg.svg';
import _bh from '@/pages/home/assets/img/flag/bh.svg';
import _bi from '@/pages/home/assets/img/flag/bi.svg';
import _bj from '@/pages/home/assets/img/flag/bj.svg';
import _bl from '@/pages/home/assets/img/flag/bl.svg';
import _bm from '@/pages/home/assets/img/flag/bm.svg';
import _bn from '@/pages/home/assets/img/flag/bn.svg';
import _bo from '@/pages/home/assets/img/flag/bo.svg';
import _bq from '@/pages/home/assets/img/flag/bq.svg';
import _br from '@/pages/home/assets/img/flag/br.svg';
import _bs from '@/pages/home/assets/img/flag/bs.svg';
import _bt from '@/pages/home/assets/img/flag/bt.svg';
import _bv from '@/pages/home/assets/img/flag/bv.svg';
import _bw from '@/pages/home/assets/img/flag/bw.svg';
import _by from '@/pages/home/assets/img/flag/by.svg';
import _bz from '@/pages/home/assets/img/flag/bz.svg';
import _ca from '@/pages/home/assets/img/flag/ca.svg';
import _cc from '@/pages/home/assets/img/flag/cc.svg';
import _cd from '@/pages/home/assets/img/flag/cd.svg';
import _cf from '@/pages/home/assets/img/flag/cf.svg';
import _cg from '@/pages/home/assets/img/flag/cg.svg';
import _ch from '@/pages/home/assets/img/flag/ch.svg';
import _ci from '@/pages/home/assets/img/flag/ci.svg';
import _ck from '@/pages/home/assets/img/flag/ck.svg';
import _cl from '@/pages/home/assets/img/flag/cl.svg';
import _cm from '@/pages/home/assets/img/flag/cm.svg';
import _cn from '@/pages/home/assets/img/flag/cn.svg';
import _co from '@/pages/home/assets/img/flag/co.svg';
import _cr from '@/pages/home/assets/img/flag/cr.svg';
import _cu from '@/pages/home/assets/img/flag/cu.svg';
import _cv from '@/pages/home/assets/img/flag/cv.svg';
import _cw from '@/pages/home/assets/img/flag/cw.svg';
import _cx from '@/pages/home/assets/img/flag/cx.svg';
import _cy from '@/pages/home/assets/img/flag/cy.svg';
import _cz from '@/pages/home/assets/img/flag/cz.svg';
import _de from '@/pages/home/assets/img/flag/de.svg';
import _default from '@/pages/home/assets/img/flag/defcountry.svg';
// import _default from '@/pages/home/assets/img/flag/default.svg';
import _dj from '@/pages/home/assets/img/flag/dj.svg';
import _dk from '@/pages/home/assets/img/flag/dk.svg';
import _dm from '@/pages/home/assets/img/flag/dm.svg';
import _do from '@/pages/home/assets/img/flag/do.svg';
import _dz from '@/pages/home/assets/img/flag/dz.svg';
import _ec from '@/pages/home/assets/img/flag/ec.svg';
import _ee from '@/pages/home/assets/img/flag/ee.svg';
import _eg from '@/pages/home/assets/img/flag/eg.svg';
import _eh from '@/pages/home/assets/img/flag/eh.svg';
import _er from '@/pages/home/assets/img/flag/er.svg';
import _es from '@/pages/home/assets/img/flag/es.svg';
import _et from '@/pages/home/assets/img/flag/et.svg';
import _eu from '@/pages/home/assets/img/flag/eu.svg';
import _fi from '@/pages/home/assets/img/flag/fi.svg';
import _fj from '@/pages/home/assets/img/flag/fj.svg';
import _fk from '@/pages/home/assets/img/flag/fk.svg';
import _fm from '@/pages/home/assets/img/flag/fm.svg';
import _fo from '@/pages/home/assets/img/flag/fo.svg';
import _fr from '@/pages/home/assets/img/flag/fr.svg';
import _ga from '@/pages/home/assets/img/flag/ga.svg';
import _gb from '@/pages/home/assets/img/flag/gb.svg';
import _gb_eng from '@/pages/home/assets/img/flag/gb-eng.svg';
import _gb_nir from '@/pages/home/assets/img/flag/gb-nir.svg';
import _gb_sct from '@/pages/home/assets/img/flag/gb-sct.svg';
import _gb_wls from '@/pages/home/assets/img/flag/gb-wls.svg';
import _gd from '@/pages/home/assets/img/flag/gd.svg';
import _ge from '@/pages/home/assets/img/flag/ge.svg';
import _gf from '@/pages/home/assets/img/flag/gf.svg';
import _gg from '@/pages/home/assets/img/flag/gg.svg';
import _gh from '@/pages/home/assets/img/flag/gh.svg';
import _gi from '@/pages/home/assets/img/flag/gi.svg';
import _gl from '@/pages/home/assets/img/flag/gl.svg';
import _global from '@/pages/home/assets/img/flag/global.svg';
import _global_wo_china from '@/pages/home/assets/img/flag/global_wo_china.svg';
import _global2 from '@/pages/home/assets/img/flag/global2.svg';
import _global_16 from '@/pages/home/assets/img/flag/global-16.svg';
import _gm from '@/pages/home/assets/img/flag/gm.svg';
import _gn from '@/pages/home/assets/img/flag/gn.svg';
import _gp from '@/pages/home/assets/img/flag/gp.svg';
import _gq from '@/pages/home/assets/img/flag/gq.svg';
import _gr from '@/pages/home/assets/img/flag/gr.svg';
import _gs from '@/pages/home/assets/img/flag/gs.svg';
import _gt from '@/pages/home/assets/img/flag/gt.svg';
import _gu from '@/pages/home/assets/img/flag/gu.svg';
import _gw from '@/pages/home/assets/img/flag/gw.svg';
import _gy from '@/pages/home/assets/img/flag/gy.svg';
import _hk from '@/pages/home/assets/img/flag/hk.svg';
import _hm from '@/pages/home/assets/img/flag/hm.svg';
import _hn from '@/pages/home/assets/img/flag/hn.svg';
import _hr from '@/pages/home/assets/img/flag/hr.svg';
import _ht from '@/pages/home/assets/img/flag/ht.svg';
import _hu from '@/pages/home/assets/img/flag/hu.svg';
import _id from '@/pages/home/assets/img/flag/id.svg';
import _ie from '@/pages/home/assets/img/flag/ie.svg';
import _il from '@/pages/home/assets/img/flag/il.svg';
import _im from '@/pages/home/assets/img/flag/im.svg';
import _in from '@/pages/home/assets/img/flag/in.svg';
import _io from '@/pages/home/assets/img/flag/io.svg';
import _iq from '@/pages/home/assets/img/flag/iq.svg';
import _ir from '@/pages/home/assets/img/flag/ir.svg';
import _is from '@/pages/home/assets/img/flag/is.svg';
import _it from '@/pages/home/assets/img/flag/it.svg';
import _je from '@/pages/home/assets/img/flag/je.svg';
import _jm from '@/pages/home/assets/img/flag/jm.svg';
import _jo from '@/pages/home/assets/img/flag/jo.svg';
import _jp from '@/pages/home/assets/img/flag/jp.svg';
import _ke from '@/pages/home/assets/img/flag/ke.svg';
import _kg from '@/pages/home/assets/img/flag/kg.svg';
import _kh from '@/pages/home/assets/img/flag/kh.svg';
import _ki from '@/pages/home/assets/img/flag/ki.svg';
import _km from '@/pages/home/assets/img/flag/km.svg';
import _kn from '@/pages/home/assets/img/flag/kn.svg';
import _kp from '@/pages/home/assets/img/flag/kp.svg';
import _kr from '@/pages/home/assets/img/flag/kr.svg';
import _kw from '@/pages/home/assets/img/flag/kw.svg';
import _ky from '@/pages/home/assets/img/flag/ky.svg';
import _kz from '@/pages/home/assets/img/flag/kz.svg';
import _la from '@/pages/home/assets/img/flag/la.svg';
import _lb from '@/pages/home/assets/img/flag/lb.svg';
import _lc from '@/pages/home/assets/img/flag/lc.svg';
import _li from '@/pages/home/assets/img/flag/li.svg';
import _lk from '@/pages/home/assets/img/flag/lk.svg';
import _lr from '@/pages/home/assets/img/flag/lr.svg';
import _ls from '@/pages/home/assets/img/flag/ls.svg';
import _lt from '@/pages/home/assets/img/flag/lt.svg';
import _lu from '@/pages/home/assets/img/flag/lu.svg';
import _lv from '@/pages/home/assets/img/flag/lv.svg';
import _ly from '@/pages/home/assets/img/flag/ly.svg';
import _ma from '@/pages/home/assets/img/flag/ma.svg';
import _mc from '@/pages/home/assets/img/flag/mc.svg';
import _md from '@/pages/home/assets/img/flag/md.svg';
import _me from '@/pages/home/assets/img/flag/me.svg';
import _mf from '@/pages/home/assets/img/flag/mf.svg';
import _mg from '@/pages/home/assets/img/flag/mg.svg';
import _mh from '@/pages/home/assets/img/flag/mh.svg';
import _mk from '@/pages/home/assets/img/flag/mk.svg';
import _ml from '@/pages/home/assets/img/flag/ml.svg';
import _mm from '@/pages/home/assets/img/flag/mm.svg';
import _mn from '@/pages/home/assets/img/flag/mn.svg';
import _mo from '@/pages/home/assets/img/flag/mo.svg';
import _mp from '@/pages/home/assets/img/flag/mp.svg';
import _mq from '@/pages/home/assets/img/flag/mq.svg';
import _mr from '@/pages/home/assets/img/flag/mr.svg';
import _ms from '@/pages/home/assets/img/flag/ms.svg';
import _mt from '@/pages/home/assets/img/flag/mt.svg';
import _mu from '@/pages/home/assets/img/flag/mu.svg';
import _mv from '@/pages/home/assets/img/flag/mv.svg';
import _mw from '@/pages/home/assets/img/flag/mw.svg';
import _mx from '@/pages/home/assets/img/flag/mx.svg';
import _my from '@/pages/home/assets/img/flag/my.svg';
import _mz from '@/pages/home/assets/img/flag/mz.svg';
import _na from '@/pages/home/assets/img/flag/na.svg';
import _nc from '@/pages/home/assets/img/flag/nc.svg';
import _ne from '@/pages/home/assets/img/flag/ne.svg';
import _nf from '@/pages/home/assets/img/flag/nf.svg';
import _ng from '@/pages/home/assets/img/flag/ng.svg';
import _ni from '@/pages/home/assets/img/flag/ni.svg';
import _nl from '@/pages/home/assets/img/flag/nl.svg';
import _no from '@/pages/home/assets/img/flag/no.svg';
import _np from '@/pages/home/assets/img/flag/np.svg';
import _nr from '@/pages/home/assets/img/flag/nr.svg';
import _nu from '@/pages/home/assets/img/flag/nu.svg';
import _nz from '@/pages/home/assets/img/flag/nz.svg';
import _om from '@/pages/home/assets/img/flag/om.svg';
// import _others from '@/pages/home/assets/img/flag/others.svg';
import _others from '@/pages/home/assets/img/flag/defcountry.svg';
import _pa from '@/pages/home/assets/img/flag/pa.svg';
import _pe from '@/pages/home/assets/img/flag/pe.svg';
import _pf from '@/pages/home/assets/img/flag/pf.svg';
import _pg from '@/pages/home/assets/img/flag/pg.svg';
import _ph from '@/pages/home/assets/img/flag/ph.svg';
import _pk from '@/pages/home/assets/img/flag/pk.svg';
import _pl from '@/pages/home/assets/img/flag/pl.svg';
import _pm from '@/pages/home/assets/img/flag/pm.svg';
import _pn from '@/pages/home/assets/img/flag/pn.svg';
import _pr from '@/pages/home/assets/img/flag/pr.svg';
import _ps from '@/pages/home/assets/img/flag/ps.svg';
import _pt from '@/pages/home/assets/img/flag/pt.svg';
import _pw from '@/pages/home/assets/img/flag/pw.svg';
import _py from '@/pages/home/assets/img/flag/py.svg';
import _qa from '@/pages/home/assets/img/flag/qa.svg';
import _re from '@/pages/home/assets/img/flag/re.svg';
import _ro from '@/pages/home/assets/img/flag/ro.svg';
import _rs from '@/pages/home/assets/img/flag/rs.svg';
import _ru from '@/pages/home/assets/img/flag/ru.svg';
import _rw from '@/pages/home/assets/img/flag/rw.svg';
import _sa from '@/pages/home/assets/img/flag/sa.svg';
import _sb from '@/pages/home/assets/img/flag/sb.svg';
import _sc from '@/pages/home/assets/img/flag/sc.svg';
import _sd from '@/pages/home/assets/img/flag/sd.svg';
import _se from '@/pages/home/assets/img/flag/se.svg';
import _sg from '@/pages/home/assets/img/flag/sg.svg';
import _sh from '@/pages/home/assets/img/flag/sh.svg';
import _si from '@/pages/home/assets/img/flag/si.svg';
import _sj from '@/pages/home/assets/img/flag/sj.svg';
import _sk from '@/pages/home/assets/img/flag/sk.svg';
import _sl from '@/pages/home/assets/img/flag/sl.svg';
import _sm from '@/pages/home/assets/img/flag/sm.svg';
import _sn from '@/pages/home/assets/img/flag/sn.svg';
import _so from '@/pages/home/assets/img/flag/so.svg';
import _sr from '@/pages/home/assets/img/flag/sr.svg';
import _ss from '@/pages/home/assets/img/flag/ss.svg';
import _st from '@/pages/home/assets/img/flag/st.svg';
import _sv from '@/pages/home/assets/img/flag/sv.svg';
import _sx from '@/pages/home/assets/img/flag/sx.svg';
import _sy from '@/pages/home/assets/img/flag/sy.svg';
import _sz from '@/pages/home/assets/img/flag/sz.svg';
import _tc from '@/pages/home/assets/img/flag/tc.svg';
import _td from '@/pages/home/assets/img/flag/td.svg';
import _tf from '@/pages/home/assets/img/flag/tf.svg';
import _tg from '@/pages/home/assets/img/flag/tg.svg';
import _th from '@/pages/home/assets/img/flag/th.svg';
import _tj from '@/pages/home/assets/img/flag/tj.svg';
import _tk from '@/pages/home/assets/img/flag/tk.svg';
import _tl from '@/pages/home/assets/img/flag/tl.svg';
import _tm from '@/pages/home/assets/img/flag/tm.svg';
import _tn from '@/pages/home/assets/img/flag/tn.svg';
import _to from '@/pages/home/assets/img/flag/to.svg';
import _tr from '@/pages/home/assets/img/flag/tr.svg';
import _tt from '@/pages/home/assets/img/flag/tt.svg';
import _tv from '@/pages/home/assets/img/flag/tv.svg';
import _tw from '@/pages/home/assets/img/flag/tw.svg';
import _tz from '@/pages/home/assets/img/flag/tz.svg';
import _ua from '@/pages/home/assets/img/flag/ua.svg';
import _ug from '@/pages/home/assets/img/flag/ug.svg';
import _uk from '@/pages/home/assets/img/flag/uk.svg';
import _um from '@/pages/home/assets/img/flag/um.svg';

// _gb-eng、_gb-nir、_gb-sct、_gb-wls、_global-16 中间是短横杠
const flagMap = {
  '_undefined': _undefined,
  '_us': _us,
  '_uy': _uy,
  '_uz': _uz,
  '_va': _va,
  '_vc': _vc,
  '_ve': _ve,
  '_vg': _vg,
  '_vi': _vi,
  '_vn': _vn,
  '_vu': _vu,
  '_wf': _wf,
  '_ws': _ws,
  '_xk': _xk,
  '_ye': _ye,
  '_yt': _yt,
  '_za': _za,
  '_zm': _zm,
  '_zw': _zw,
  '_': _,
  '_ad': _ad,
  '_ae': _ae,
  '_af': _af,
  '_ag': _ag,
  '_ai': _ai,
  '_al': _al,
  '_am': _am,
  '_ao': _ao,
  '_aq': _aq,
  '_ar': _ar,
  '_as': _as,
  '_at': _at,
  '_au': _au,
  '_aw': _aw,
  '_ax': _ax,
  '_az': _az,
  '_ba': _ba,
  '_bb': _bb,
  '_bd': _bd,
  '_be': _be,
  '_bf': _bf,
  '_bg': _bg,
  '_bh': _bh,
  '_bi': _bi,
  '_bj': _bj,
  '_bl': _bl,
  '_bm': _bm,
  '_bn': _bn,
  '_bo': _bo,
  '_bq': _bq,
  '_br': _br,
  '_bs': _bs,
  '_bt': _bt,
  '_bv': _bv,
  '_bw': _bw,
  '_by': _by,
  '_bz': _bz,
  '_ca': _ca,
  '_cc': _cc,
  '_cd': _cd,
  '_cf': _cf,
  '_cg': _cg,
  '_ch': _ch,
  '_ci': _ci,
  '_ck': _ck,
  '_cl': _cl,
  '_cm': _cm,
  '_cn': _cn,
  '_co': _co,
  '_cr': _cr,
  '_cu': _cu,
  '_cv': _cv,
  '_cw': _cw,
  '_cx': _cx,
  '_cy': _cy,
  '_cz': _cz,
  '_de': _de,
  '_default': _default,
  '_dj': _dj,
  '_dk': _dk,
  '_dm': _dm,
  '_do': _do,
  '_dz': _dz,
  '_ec': _ec,
  '_ee': _ee,
  '_eg': _eg,
  '_eh': _eh,
  '_er': _er,
  '_es': _es,
  '_et': _et,
  '_eu': _eu,
  '_fi': _fi,
  '_fj': _fj,
  '_fk': _fk,
  '_fm': _fm,
  '_fo': _fo,
  '_fr': _fr,
  '_ga': _ga,
  '_gb': _gb,
  '_gb-eng': _gb_eng,
  '_gb-nir': _gb_nir,
  '_gb-sct': _gb_sct,
  '_gb-wls': _gb_wls,
  '_gd': _gd,
  '_ge': _ge,
  '_gf': _gf,
  '_gg': _gg,
  '_gh': _gh,
  '_gi': _gi,
  '_gl': _gl,
  '_global': _global,
  '_global_wo_china': _global_wo_china,
  '_global2': _global2,
  '_global-16': _global_16,
  '_gm': _gm,
  '_gn': _gn,
  '_gp': _gp,
  '_gq': _gq,
  '_gr': _gr,
  '_gs': _gs,
  '_gt': _gt,
  '_gu': _gu,
  '_gw': _gw,
  '_gy': _gy,
  '_hk': _hk,
  '_hm': _hm,
  '_hn': _hn,
  '_hr': _hr,
  '_ht': _ht,
  '_hu': _hu,
  '_id': _id,
  '_ie': _ie,
  '_il': _il,
  '_im': _im,
  '_in': _in,
  '_io': _io,
  '_iq': _iq,
  '_ir': _ir,
  '_is': _is,
  '_it': _it,
  '_je': _je,
  '_jm': _jm,
  '_jo': _jo,
  '_jp': _jp,
  '_ke': _ke,
  '_kg': _kg,
  '_kh': _kh,
  '_ki': _ki,
  '_km': _km,
  '_kn': _kn,
  '_kp': _kp,
  '_kr': _kr,
  '_kw': _kw,
  '_ky': _ky,
  '_kz': _kz,
  '_la': _la,
  '_lb': _lb,
  '_lc': _lc,
  '_li': _li,
  '_lk': _lk,
  '_lr': _lr,
  '_ls': _ls,
  '_lt': _lt,
  '_lu': _lu,
  '_lv': _lv,
  '_ly': _ly,
  '_ma': _ma,
  '_mc': _mc,
  '_md': _md,
  '_me': _me,
  '_mf': _mf,
  '_mg': _mg,
  '_mh': _mh,
  '_mk': _mk,
  '_ml': _ml,
  '_mm': _mm,
  '_mn': _mn,
  '_mo': _mo,
  '_mp': _mp,
  '_mq': _mq,
  '_mr': _mr,
  '_ms': _ms,
  '_mt': _mt,
  '_mu': _mu,
  '_mv': _mv,
  '_mw': _mw,
  '_mx': _mx,
  '_my': _my,
  '_mz': _mz,
  '_na': _na,
  '_nc': _nc,
  '_ne': _ne,
  '_nf': _nf,
  '_ng': _ng,
  '_ni': _ni,
  '_nl': _nl,
  '_no': _no,
  '_np': _np,
  '_nr': _nr,
  '_nu': _nu,
  '_nz': _nz,
  '_om': _om,
  '_others': _others,
  '_pa': _pa,
  '_pe': _pe,
  '_pf': _pf,
  '_pg': _pg,
  '_ph': _ph,
  '_pk': _pk,
  '_pl': _pl,
  '_pm': _pm,
  '_pn': _pn,
  '_pr': _pr,
  '_ps': _ps,
  '_pt': _pt,
  '_pw': _pw,
  '_py': _py,
  '_qa': _qa,
  '_re': _re,
  '_ro': _ro,
  '_rs': _rs,
  '_ru': _ru,
  '_rw': _rw,
  '_sa': _sa,
  '_sb': _sb,
  '_sc': _sc,
  '_sd': _sd,
  '_se': _se,
  '_sg': _sg,
  '_sh': _sh,
  '_si': _si,
  '_sj': _sj,
  '_sk': _sk,
  '_sl': _sl,
  '_sm': _sm,
  '_sn': _sn,
  '_so': _so,
  '_sr': _sr,
  '_ss': _ss,
  '_st': _st,
  '_sv': _sv,
  '_sx': _sx,
  '_sy': _sy,
  '_sz': _sz,
  '_tc': _tc,
  '_td': _td,
  '_tf': _tf,
  '_tg': _tg,
  '_th': _th,
  '_tj': _tj,
  '_tk': _tk,
  '_tl': _tl,
  '_tm': _tm,
  '_tn': _tn,
  '_to': _to,
  '_tr': _tr,
  '_tt': _tt,
  '_tv': _tv,
  '_tw': _tw,
  '_tz': _tz,
  '_ua': _ua,
  '_ug': _ug,
  '_uk': _uk,
  '_um': _um,
};


/** flagMap 中不参与业务枚举的兜底 key */
const FLAG_MAP_SKIP_KEYS = new Set(['_undefined', '_default', '_']);

/**
 * 与 flagMap 同步的国家/地区 code 列表（供各模块枚举国旗，不含兜底项）。
 * 新增国旗资源时只需维护 flagMap，本列表会自动更新。
 */
export const COUNTRY_FLAG_ICON_CODES: readonly string[] = Object.keys(flagMap)
  .filter((key) => !FLAG_MAP_SKIP_KEYS.has(key))
  .map((key) => key.slice(1));

/**
 * code: 国家缩写
 * source：扩展字段外部自定义源，优先从外部取，外部没有，从内部取
 * gemeCode：扩展字段游戏code，有些游戏可能会把某些国家的国旗强制换掉，方便后续方法的扩展
 */
export const getCountryFlag = (code: string, source?: object) => {
  const countryCode = code ? `_${code?.toLowerCase()?.trim()}` : '_default';
  if (!source) {
    source = flagMap;
  }
  return source[countryCode] || source._default;
};
